import {
	fomatTime,
	fomatTimeStr, getWeekFirstDay, getYearWeekCompletion,
} from '@/components/common/utils/time.js'
import {
	toThousands,
} from '@/components/common/utils/fomatNum.js'
import { changeDecimal } from '@/components/common/utils/fomatNum.js'

export function fomatRankTrendsDataMini(list) {
	let data_arr = []
	list = list || []
	let search_frequency_rank = {
		name: '搜索排名',
		type: 'area',
		connectNulls: true,
		data: [],
		zoneAxis: 'x',
		zones: [],
	}
	list.forEach((i, index) => {
		let date = i.date
		let name = {
			date: date,
			lastData: i.data
		}
		let currentDate = new Date(date);
		if (index > 0){
			let lastDate = new Date(list[index - 1].date);
			let diffInTime = currentDate.getTime() - lastDate.getTime();
			let diffInDays = diffInTime / (1000 * 3600 * 24);
			if (diffInDays > 7){
				search_frequency_rank.data.push({
					x: currentDate,
					y: i.value,
					name: JSON.stringify(name)
				})
				search_frequency_rank.zones.push({
					value: currentDate,
					dashStyle: "longDash",
					color: "#d4d4d4"
				})
			} else {
				search_frequency_rank.data.push({
					x: currentDate,
					y: i.value,
					name: JSON.stringify(name)
				})
				search_frequency_rank.zones.push({
					value: currentDate
				})
			}
		} else {
			search_frequency_rank.data.push({
				x: currentDate,
				y: i.value,
				name: JSON.stringify(name)
			})
			search_frequency_rank.zones.push({
				value: currentDate,
				dashStyle: "longDash",
				color: "#d4d4d4"
			})
		}
	})
	// console.log(search_frequency_rank.data.map(i => JSON.parse(i.name)))
	data_arr.push(search_frequency_rank)
	let option = getOption(data_arr)
	// let data = search_frequency_rank.data.map(i => i.y);
	// let processedData = removeOutliers(data);
	// let min = Math.min(...processedData);
	// let max = Math.max(...processedData);
	// let minLog = Math.floor(Math.log10(min));
	// let maxLog = Math.ceil(Math.log10(max));
	// let rangeLog = maxLog - minLog;
	// let tickInterval;
	// if (rangeLog < 2) {
	// 	tickInterval = 0.1;
	// } else if (rangeLog < 3) {
	// 	tickInterval = 0.2;
	// } else {
	// 	tickInterval = 0.5;
	// }
	// option.yAxis.type = 'logarithmic'
	// option.yAxis.tickInterval = tickInterval
	return option
}


export function fomatRankTrendsDataMiniV2(currentDataDate, list) {
	let data_arr = []
	list = list || []
	let search_frequency_rank = {
		name: '搜索排名',
		type: 'area',
		connectNulls: true,
		data: [],
		zoneAxis: 'x',
		zones: [],
	}

	list.forEach((i, index) => {
		let date = i.date
		let name = {
			date: date,
			lastData: i.data
		}
		let currentDate = new Date(date);
		if (index > 0){
			let lastDate = new Date(list[index - 1].date);
			let diffInTime = currentDate.getTime() - lastDate.getTime();
			let diffInDays = diffInTime / (1000 * 3600 * 24);
			if (diffInDays > 7){
				search_frequency_rank.data.push({
					x: currentDate.getTime(),
					y: i.value,
					name: JSON.stringify(name)
				})
				search_frequency_rank.zones.push({
					value: currentDate.getTime(),
					dashStyle: "longDash",
					color: "#d4d4d4"
				})
			} else {
				search_frequency_rank.data.push({
					x: currentDate.getTime(),
					y: i.value,
					name: JSON.stringify(name)
				})
				search_frequency_rank.zones.push({
					value: currentDate.getTime()
				})
			}
		} else {
			search_frequency_rank.data.push({
				x: currentDate.getTime(),
				y: i.value,
				name: JSON.stringify(name)
			})
			search_frequency_rank.zones.push({
				value: currentDate.getTime(),
				dashStyle: "longDash",
				color: "#d4d4d4"
			})
		}
	})
	// console.log(search_frequency_rank.data.map(i => JSON.parse(i.name)))
	data_arr.push(search_frequency_rank)
	let option = getOption(data_arr)
	// let endDate = new Date(currentDataDate);
	// let startDate = new Date(currentDataDate);
	// startDate.setDate(startDate.getDate() - 13 * 7);
	// while (startDate.getTime() <= endDate.getTime()) {
	// 	let date = new Date(startDate);
	// 	startDate.setDate(startDate.getDate() + 7);
	// }
	// console.log(option)
	// let data = search_frequency_rank.data.map(i => i.y);
	// let processedData = removeOutliers(data);
	// let min = Math.min(...processedData);
	// let max = Math.max(...processedData);
	// let minLog = Math.floor(Math.log10(min));
	// let maxLog = Math.ceil(Math.log10(max));
	// let rangeLog = maxLog - minLog;
	// let tickInterval;
	// if (rangeLog < 2) {
	// 	tickInterval = 0.1;
	// } else if (rangeLog < 3) {
	// 	tickInterval = 0.2;
	// } else {
	// 	tickInterval = 0.5;
	// }
	// option.yAxis.type = 'logarithmic'
	// option.yAxis.tickInterval = tickInterval
	return option
}


const down = '<i class="fa fa-long-arrow-down" style=" color:#cf1322;"></i>'
const up = '<i class="fa fa-long-arrow-up" style=" color:#67C23A;"></i>'

function removeOutliers(data) {
    data.sort((a, b) => a - b);
    let q1 = data[Math.floor(data.length / 4)];
    let q3 = data[Math.floor(data.length * 3 / 4)];
    let iqr = q3 - q1;
    let lowerBound = q1 - 1.5 * iqr;
    let upperBound = q3 + 1.5 * iqr;
    return data.filter(value => value >= lowerBound && value <= upperBound);
}

function fomatUpDownIcon(num) {
	let str = ''
	if (num > 0) {
		str += up
	} else if (num < 0) {
		str += down
	}
	return str
}

function createDot(color) {
	let str = "<div style='border-radius: 50%;" +
		"display: inline-block;margin: 0 5px;" +
		"background-color:" + color + ";" +
		"height: 10px;" +
		"width: 10px;'></div>"
	return str
}

function getOption(data_arr) {
	return {
		chart: {
			margin: [0, 0, 0, 0],
			backgroundColor: 'rgba(105, 185, 255, 0.1)'
		},
		title: {
			text: ' '
		},
		xAxis: {
			crosshair: true, // 启用 x 轴准星线
			visible: false,
		},
		yAxis: {
			reversed: true,
			visible: false,
		},
		credits: {
			enabled: false
		},
		legend: {
			enabled: false
		},
		tooltip: {
			hideDelay: 100,
			outside: true,
			useHTML: true,
			headerFormat: null,
			pointFormatter: function() {
				let name = JSON.parse(this.options.name)
				let htmlStr = '<div style="width:250px;font-size:15px;position: relative;">'
				htmlStr += '<p style="margin-top: 5px;">' + fomatTimeStr(name.date) + '</p>'
				htmlStr += "<div style='line-height:25px;'>"
				htmlStr += "<div>"
				htmlStr += createDot('#a0d911') + "当前排名:" +
					'<span style="float:right;margin-right: 5px;">' +
					toThousands(this.options.y)
				htmlStr += "</span></div>"
				if (name.lastData) {
					let lastData = name.lastData
					htmlStr += "<div>"
					htmlStr += createDot('#fa541c') + "上周排名:" +
						'<span style="float:right;margin-right: 5px;">' +
						toThousands(lastData.value)
					htmlStr += "</span></div>"

					htmlStr += "<div>"
					htmlStr += createDot('#faad14') + "排名变化:" +
						'<span style="float:right;margin-right: 5px;">' +
						fomatUpDownIcon(lastData.growth_value) + '&nbsp' +
						toThousands(Math.abs(lastData.growth_value)) + '&nbsp(' +
						// fomatUpDownIcon(lastData.growth_rate) + '&nbsp' +
						changeDecimal(Math.abs(lastData.growth_rate) * 100) + '%)'
					htmlStr += "</span></div>"
				}
				htmlStr += '</div></div>'
				return htmlStr
			}
		},
		plotOptions: {
			area: {
				fillColor: '#ffffff'
			},
			series: {
				animation: false,
				lineWidth: 2,
				shadow: false,
				states: {
					hover: {
						lineWidth: 2
					}
				},
				marker: {
					radius: 1,
				},
		// 		// fillOpacity: 0.25
			},
		},
		series: data_arr
	}
}
